/**
 * @generated SignedSource<<ec0a8955e8c914327806e88626ec8e41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddDefaultFileAttachmentInput = {
  clientMutationId?: string | null;
  descriptionOpt?: string | null;
  fileId: string;
  nodeId: string;
  titleOpt?: string | null;
};
export type CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation$variables = {
  input: AddDefaultFileAttachmentInput;
};
export type CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly addDefaultFileAttachment: {
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"AttachmentEditor_TreeNodeFragment">;
        };
      } | null;
    };
  };
};
export type CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation = {
  response: CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation$data;
  variables: CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddDefaultFileAttachmentPayload",
                "kind": "LinkedField",
                "name": "addDefaultFileAttachment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AttachmentEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddDefaultFileAttachmentPayload",
                "kind": "LinkedField",
                "name": "addDefaultFileAttachment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "attachments",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "kind",
                            "storageKey": null
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isAttachmentV2"
                          },
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "File",
                                "kind": "LinkedField",
                                "name": "file",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "description",
                                "storageKey": null
                              }
                            ],
                            "type": "DefaultFileAttachment",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "89ccb777c8ae4655b93f0b9bafc3dbcf",
    "id": null,
    "metadata": {},
    "name": "CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation",
    "operationKind": "mutation",
    "text": "mutation CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation(\n  $input: AddDefaultFileAttachmentInput!\n) {\n  Admin {\n    Tree {\n      addDefaultFileAttachment(input: $input) {\n        node {\n          ...AttachmentEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment AttachmentEditor_TreeNodeFragment on TreeNode {\n  id\n  attachments {\n    __typename\n    kind\n    ... on DefaultFileAttachment {\n      id\n      file {\n        id\n        name\n      }\n      title\n      description\n      kind\n    }\n    ...DefaultFileAttachmentForm_AttachmentV2Fragment\n    id\n  }\n}\n\nfragment DefaultFileAttachmentForm_AttachmentV2Fragment on AttachmentV2 {\n  __isAttachmentV2: __typename\n  ... on DefaultFileAttachment {\n    file {\n      id\n      name\n    }\n    title\n    description\n  }\n  kind\n}\n"
  }
};
})();

(node as any).hash = "9b81670a8c0c7720295d51e6f2d613db";

export default node;
